import { Lock } from "lucide-react";

interface RestrictedSectionProps {
  label: string;
}

export const RestrictedSection = ({ label }: RestrictedSectionProps) => (
  <div className="flex items-center gap-2 text-sm text-muted-foreground py-1">
    <Lock className="h-3.5 w-3.5 flex-shrink-0" />
    <span>{label}</span>
  </div>
);
